import Selector from '../selector';
import BarQrCodeImg from '../bar_qrcode_img';

export default class ImageManage {
  constructor(overlayerCEl,data,table) {
    //存储临时条形码、二维码显示信息
    this.imagesArr = [];
    //image标签父级标签
    this.overlayerCEl = overlayerCEl;
    // selector
    this.selector = new Selector(data);
    this.data = data;
    this.table = table;
  }

  //处理图片显示位置Offset
  imageSetOffset(moveType,distance,data) {
    console.log("ImageManage imageSetOffset......",moveType,distance );
    this.imagesArr.forEach(imgObj => {
      imgObj.setImageOffset(data,distance,moveType);
    });
  }

  //处理单元格或者选择区域类型的配置
  updateConfig(ri, ci,type,config,data){
    let configKey = ri+'-'+ci+'-key';
    if (!config) {
      config = {...data.configInit[type]}
    }
    if (data.config[configKey]) {
      data.config[configKey][type] = {...config};
    }else{
      data.config[configKey] = {};
      data.config[configKey][type] = {...config}
    }
  }

  //处理图片显示
  imageSet(ri, ci,type,overlayerCEl,data,config) {
    console.log('imageSet this.imagesArr:');
    let imgObj = this.imagesArr.find(item=>{
      return item.ri === ri && item.ci === ci;
    })
    if (imgObj) {
      this.imageRemove(ri, ci,overlayerCEl,data);
    }

    let configKey = ri+'-'+ci+'-key';
    let configObj = null;
    if (config) {
      configObj = config
    }else{
      if (data.config && data.config[configKey] && Object.keys(data.config[configKey]).length>0) {
        if (data.config[configKey][type]) {
          configObj = {...data.config[configKey][type]};
        }
      }
      if (!configObj && imgObj && imgObj.config) {
        configObj = {...imgObj.config};
      }
    }
    this.updateConfig(ri, ci,type,configObj,data);

    imgObj = new BarQrCodeImg(
      ri, ci,type,data.rows.height,configObj
    );
    overlayerCEl.child(imgObj.el);
    this.imagesArr.push(imgObj);
    console.log('this.imagesArr:', this.imagesArr);

    if (data.settings.mode === 'read') return;
    imgObj.setImageOffset(data);
    imgObj.setImageCell(data.getCell(ri, ci), data);
  }
  //隐藏图片显示
  imageHide(ri, ci,data) {
    let imgObj = this.imagesArr.find(item=>{
      return item.ri === ri && item.ci === ci;
    })
    console.log('imgObj:', imgObj);
    if (imgObj) {
      imgObj.hideImage();
    }
  }
  //移除图片
  imageRemove(ri, ci,overlayerCEl,data) {
    let imgObjIndex = this.imagesArr.findIndex(item=>{
      return item.ri === ri && item.ci === ci;
    })
    if (imgObjIndex>-1) {
      let imgObj = this.imagesArr[imgObjIndex];
      if (imgObj) {
        overlayerCEl.removeChild(imgObj.el.el);
        this.imagesArr.splice(imgObjIndex,1);
        //移除配置信息中的图片信息
        let configKey = ri+'-'+ci+'-key';
        if (data && data.config && data.config[configKey] && data.config[configKey][imgObj.imageType]) {
          delete data.config[configKey][imgObj.imageType];
        }
      }
    }
  }
  //清空选择的cell 图片
  clearSelectCellsImage(overlayerCEl,data){
    const selector = data.selector;
    selector.range.each((ri, ci) => {
      console.log('clearSelectCellsImage cell:',ri, ci);
      this.imageRemove(ri, ci,overlayerCEl,data);
    });
  }

  //清空imagesArr数组
  clearImagesArr(overlayerCEl,data){
    this.imagesArr.forEach(imgObj => {
      if (imgObj) {
        overlayerCEl.removeChild(imgObj.el.el);
      }
    });
    this.imagesArr = [];
  }

  //处理资源图片合并单元格
  mergeImages(type,value,data,overlayerCEl) {
    console.log('mergeImages:', type,value);
    const { selector, rows } = data;
    console.log('mergeImages data.selector.multiple():', data.selector.multiple());
    if (!data.selector.multiple()) return;
    
    const [rn, cn] = selector.size();
    console.log('merge:', rn, cn);
    if (rn > 1 || cn > 1) {
      const { sri, sci } = selector.range;
      let sCellStyle = data.getCellStyle(sri, sci);
      console.log('merge sCellStyle:', sCellStyle);
      if (sCellStyle && (sCellStyle.format=='qrcode' || sCellStyle.format=='barcode' || sCellStyle.format=='image' || sCellStyle.cellimage)) {
        if (sCellStyle.cellimage) {
          this.imageSet(sri, sci,'cellimage',overlayerCEl,data);
        }else{
          this.imageSet(sri, sci,sCellStyle.format,overlayerCEl,data);
        }
      }
    }
  }
  //处理当行列增加或者删除时，资源this.imagesArr中ri ci同步更新
  dealBarqrCodesWithRowColAddRemove(editType,rcType,data,table,overlayerCEl){
    const { selector } = data;
    const { sri, sci, eri, eci, } = selector.range;
    if (rcType === 'row') {
      if (editType == 'delete') {
        let n = eri-sri+1;
        for (let nCi = sci; nCi <= eci; nCi++) {
          for (let index = 0; index < this.imagesArr.length; index++) {
            const element = this.imagesArr[index];
            if(element.ci==nCi && element.ri==sri){
              console.log("row delete imagesArr nCi......",nCi);
              this.imageRemove(element.ri, element.ci,overlayerCEl,data);
              break;
            }
          }
        }
        for (const key in table.imagesArr) {
          let imgObj = table.imagesArr[key];
          if (imgObj.ri>eri) {
            imgObj.ri-=n;
          }
        }
        for (const key in this.imagesArr) {
          let imgObj = this.imagesArr[key];
          if (imgObj.ri>eri) {
            imgObj.ri-=n;
          }
        }
        
      } else if (editType == 'add') {
        for (const key in table.imagesArr) {
          let imgObj = table.imagesArr[key];
          if (imgObj.ri>=sri) {
            imgObj.ri+=1;
          }
        }
        for (const key in this.imagesArr) {
          let imgObj = this.imagesArr[key];
          if (imgObj.ri>=sri) {
            imgObj.ri+=1;
          }
        }
      }
    } else if (rcType === 'column') {
      if (editType == 'delete') {
        let n = eci-sci+1;
        for (let nRi = sri; nRi <= eri; nRi++) {
          for (let index = 0; index < this.imagesArr.length; index++) {
            const element = this.imagesArr[index];
            if(element.ri==nRi && element.ci==sci){
              console.log("column delete imagesArr nRi......",nRi);
              this.imageRemove(element.ri, element.ci,overlayerCEl,data);
              break;
            }
          }
        }
        for (const key in table.imagesArr) {
          let imgObj = table.imagesArr[key];
          if (imgObj.ci>eci) {
            imgObj.ci-=n;
          }
        }
        for (const key in this.imagesArr) {
          let imgObj = this.imagesArr[key];
          if (imgObj.ci>eci) {
            imgObj.ci-=n;
          }
        }
      } else if (editType == 'add') {
        for (const key in table.imagesArr) {
          let imgObj = table.imagesArr[key];
          if (imgObj.ci>=sci) {
            imgObj.ci+=1;
          }
        }
        for (const key in this.imagesArr) {
          let imgObj = this.imagesArr[key];
          if (imgObj.ci>=sci) {
            imgObj.ci+=1;
          }
        }
      }
    }
    table.render();
    // table.render();
    if (rcType === 'row') {
      if (editType == 'add') {
        this.imageSetOffset('vertical');
      }else{
        this.imageSetOffset('horizontal');
      }
      
    }else{
      if (editType == 'add') {
        this.imageSetOffset('horizontal');
      }else{
        this.imageSetOffset('vertical');
      }
    }
  }
}
